import { atom, useAtom, useAtomValue } from 'jotai';
import { atomWithCookieStorage } from '~/atoms/atomWithCookieStorage';
import { authTokenKey } from '~/constants/storage';
import type { ILoginSuccessful } from '~/types/authentification';

export const userAtom = atomWithCookieStorage<ILoginSuccessful | null>(authTokenKey, null);
export const useUser = () => useAtom(userAtom);

export const accessTokenAtom = atom((get) => get(userAtom)?.accessToken ?? null);

// Récupère l'email de l'utilisateur connecté
export const userEmailAtom = atom((get) => get(userAtom)?.email ?? null);
export const useUserEmail = () => useAtomValue(userEmailAtom);
